import React from 'react'
import {
  Button,
  Dialog,
  Card,
  CardBody,
  CardFooter,
} from "@material-tailwind/react";
import { PencilIcon, XMarkIcon } from '@heroicons/react/24/outline';
import AutocompleteUser from './AutocompleteUser';
const CreateWarehouse = ({ warehouseModal, handleWarehouseModal, setWarehouseModal, setWarehouseData, warehouseData, handleWarehouse, pickupName, setPickupName, userList }) => {
  const fieldGroups = [
    { key: 'pinCode', label: 'Pin Code', placeholder: 'Pin code', className: 'xl:col-span-1' },
    { key: 'city', label: 'City', placeholder: 'City', className: 'xl:col-span-1' },
    { key: 'state', label: 'State', placeholder: 'State', className: 'xl:col-span-1' },
    { key: 'country', label: 'Country', placeholder: 'Country', className: 'xl:col-span-1' },
    { key: 'address', label: 'Address', placeholder: 'Full street address', className: 'md:col-span-2 xl:col-span-2' },
    { key: 'personName', label: 'Contact Person', placeholder: 'Contact person name', className: 'xl:col-span-1' },
    { key: 'email', label: 'Email', placeholder: 'Email address', className: 'xl:col-span-1' },
    { key: 'phone', label: 'Phone Number', placeholder: 'Phone number', className: 'xl:col-span-1' },
  ]

  return (
    <div>
      <div>
        <Dialog
          size="lg"
          open={warehouseModal}
          handler={handleWarehouseModal}
          className="bg-transparent  shadow-none"
        >
          <Card className="relative w-full overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-[0_28px_60px_rgba(15,23,42,0.14)]">
            <div className='border-b border-slate-100 px-6 py-5'>
              <div className='flex items-start justify-between gap-4'>
                <div>
                  <p className='text-[10px] font-[GilroyBold] uppercase tracking-[0.18em] text-[#f97316]'>Warehouse setup</p>
                  <h3 className='mt-2 text-[1.5rem] font-[GilroyBold] tracking-[-0.03em] text-slate-950'>Create warehouse</h3>
                  <p className='mt-1 text-sm font-[GilroyMedium] text-slate-500'>Add a client-linked warehouse record with location, contact, and preferred pickup slot details.</p>
                </div>
                <button type='button' onClick={() => setWarehouseModal(!warehouseModal)} className="flex h-10 w-10 items-center justify-center rounded-full text-slate-500 transition hover:bg-slate-100">
                  <XMarkIcon className='h-6 w-6' />
                </button>
              </div>
            </div>
            <CardBody className="max-h-[70vh] overflow-y-auto px-6 py-6">
              <div className='grid gap-5'>
                <div className='rounded-[24px] border border-slate-200 bg-slate-50/80 p-5'>
                  <p className='mb-3 text-[11px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-500'>Client mapping</p>
                  {Object.keys(pickupName).length === 0 ? <AutocompleteUser selected={pickupName} setSelected={setPickupName} placeholder="Search client name" data={userList} /> : <div className='rounded-[20px] border border-slate-200 bg-white px-4 py-4 shadow-[0_8px_24px_rgba(15,23,42,0.04)]'>
                    <div className='flex items-start justify-between gap-3'>
                      <div>
                        <h3 className='text-sm font-[GilroyBold] text-slate-900'>{pickupName.name || '-'}</h3>
                        <p className='mt-1 text-[13px] font-[GilroyMedium] text-slate-500'>{pickupName.email || '-'}</p>
                        <p className='mt-1 text-[13px] font-[GilroyMedium] text-slate-500'>{pickupName.companyName || '-'}</p>
                      </div>
                      <button type='button' onClick={() => setPickupName({})} className='rounded-full p-2 text-slate-500 transition hover:bg-slate-100'>
                        <PencilIcon className='h-5 w-5' />
                      </button>
                    </div>
                  </div>}
                </div>

                <div className='rounded-[24px] border border-slate-200 bg-[linear-gradient(180deg,_#ffffff,_#f8fafc)] p-5'>
                  <div className='mb-4 border-b border-slate-100 pb-4'>
                    <p className='text-sm font-[GilroyBold] uppercase tracking-[0.14em] text-slate-400'>Warehouse details</p>
                    <p className='mt-1 text-sm text-slate-500'>Capture the address, operating contact, and slot preference for this warehouse.</p>
                  </div>
                  <div className='grid gap-5 md:grid-cols-2 xl:grid-cols-4'>
                    {fieldGroups.map((field) => (
                      <label key={field.key} className={`block ${field.className}`}>
                        <span className='mb-2 block text-[11px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-500'>{field.label}</span>
                        <input
                          value={warehouseData[field.key]}
                          onChange={(e) => setWarehouseData({ ...warehouseData, [field.key]: e.target.value })}
                          type="text"
                          placeholder={field.placeholder}
                          className='h-14 w-full rounded-[18px] border border-slate-200 bg-white px-4 text-base font-[GilroyMedium] text-slate-900 shadow-[0_8px_20px_rgba(15,23,42,0.04)] outline-none transition placeholder:text-slate-300 focus:border-[#f97316] focus:ring-4 focus:ring-[#f97316]/10'
                        />
                      </label>
                    ))}

                    <label className='block md:col-span-2 xl:col-span-1'>
                      <span className='mb-2 block text-[11px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-500'>Preferred Slot</span>
                      <select value={warehouseData.slot} onChange={(e) => setWarehouseData({ ...warehouseData, slot: e.target.value })} className='h-14 w-full rounded-[18px] border border-slate-200 bg-white px-4 text-base font-[GilroyMedium] text-slate-900 shadow-[0_8px_20px_rgba(15,23,42,0.04)] outline-none transition focus:border-[#f97316] focus:ring-4 focus:ring-[#f97316]/10'>
                        <option value=''>Select preferred slot</option>
                        <option value='01:00 Pm - 04:00 Pm'>01:00 Pm - 04:00 Pm</option>
                        <option value='04:00 Pm - 07:00 Pm'>04:00 Pm - 07:00 Pm</option>
                        <option value='07:00 Pm - 10:00 Pm'>07:00 Pm - 10:00 Pm</option>
                      </select>
                    </label>
                  </div>
                </div>
              </div>
            </CardBody>
            <CardFooter className="flex items-center justify-end gap-3 border-t border-slate-100 bg-slate-50/80 px-6 py-4">
              <Button onClick={() => setWarehouseModal(!warehouseModal)} className='rounded-full bg-slate-200 px-5 py-2.5 text-xs font-[GilroyBold] text-slate-700 shadow-none hover:bg-slate-300'>Cancel</Button>
              <Button onClick={handleWarehouse} className='rounded-full bg-[#f97316] px-6 py-2.5 text-xs font-[GilroyBold] text-white shadow-[0_12px_24px_rgba(249,115,22,0.22)] hover:bg-[#ea580c]'>Create Warehouse</Button>
            </CardFooter>
          </Card>
        </Dialog>
      </div>
    </div>
  )
}

export default CreateWarehouse
